import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Tag } from '@/shared/components/ui/tag/tag';
import { TStepTag } from '@/shared/components/ui/tag/variant/step-tag/step-tag.types';

export const StepTag: React.FC<TStepTag> = ({ currentStep, maxSteps }) => {
  const { t } = useTranslation();
  const step = t('ui:step');
  const displayCurrentStep = currentStep + 1;

  const displayText = `${step} ${displayCurrentStep} / ${maxSteps}`;

  return (
    <Tag
      label={
        <Typography color="primary" variant="p9">
          {displayText}
        </Typography>
      }
    />
  );
};
